import axios from "axios";

export const APISM = axios.create({
  baseURL: process.env.REACT_APP_SM,
});

export const setAuthToken = (token) => {
  if (token) {
    APISM.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete APISM.defaults.headers.commin["Authorization"];
  }
};
